const isDev = () => typeof window !== 'undefined' && !!window.location.href.match(/http:\/\/localhost/)
const baseurl = isDev() ? 'http://localhost:3000' : 'https://api.все-новостройки-москва.рф'
const url = u => `${baseurl}/${u}`

export default {
  sessions: {
    send(session) {
      return fetch(url('v1/sessions'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(session)
      })
    }
  },
  answers: {
    send(answer) {
      return fetch(url('v1/answers'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(answer)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./api/index.js